export default "__VITE_ASSET__Co51zoPk__"